export class TruckVisit {
    estimatedArrivalDate = null;
    orderDate = null;
}
